var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17.707C8.7811 17.707 7.69089 17.1561 6.96477 16.2897C6.50614 17.1339 5.61167 17.707 4.58333 17.707C3.08756 17.707 1.875 16.4945 1.875 14.9987V8.33203C1.875 6.83626 3.08756 5.6237 4.58333 5.6237C5.6186 5.6237 6.5182 6.20457 6.97399 7.05817C7.04844 6.93571 7.12867 6.80537 7.21512 6.66493L9.11389 3.57943C9.44752 3.03728 10.0385 2.70703 10.6751 2.70703C11.7986 2.70703 12.6578 3.70848 12.4869 4.81892L12.2844 6.1354C12.1236 7.18086 12.9324 8.1237 13.9902 8.1237H14.565C17.1438 8.1237 18.821 10.8375 17.6678 13.1441L16.7107 15.0583C15.899 16.6816 14.2398 17.707 12.4249 17.707H10ZM10.1785 4.23455C10.2846 4.06209 10.4726 3.95703 10.6751 3.95703C11.0325 3.95703 11.3058 4.2756 11.2515 4.62885L11.0489 5.94533C10.7716 7.74799 12.1663 9.3737 13.9902 9.3737H14.565C16.2145 9.3737 17.2874 11.1096 16.5497 12.5851L15.5926 14.4992C14.9927 15.6991 13.7663 16.457 12.4249 16.457H10C8.50423 16.457 7.29167 15.2445 7.29167 13.7487V10.8871C7.29167 9.90748 7.29526 9.5134 7.38039 9.14026C7.40746 9.02164 7.44061 8.90449 7.47973 8.78928C7.60279 8.42688 7.80627 8.08937 8.31969 7.25507L10.1785 4.23455ZM4.58333 6.8737C5.38875 6.8737 6.04167 7.52662 6.04167 8.33203V14.9987C6.04167 15.8041 5.38875 16.457 4.58333 16.457C3.77792 16.457 3.125 15.8041 3.125 14.9987V8.33203C3.125 7.52662 3.77792 6.8737 4.58333 6.8737Z",
    fill: "#838383"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLike);
export default __webpack_public_path__ + "static/media/ic_like.6e81049b6efa980988bb3201a3a02135.svg";
export { ForwardRef as ReactComponent };